module.exports = __webpack_public_path__ + "static/assets/5af5df2c8f0163c7fe0af2af9340efb6.svg";